import { render, staticRenderFns } from "./TeacherGroupPageForm.vue?vue&type=template&id=8fdeb428&scoped=true&"
import script from "./TeacherGroupPageForm.vue?vue&type=script&lang=js&"
export * from "./TeacherGroupPageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdeb428",
  null
  
)

export default component.exports